module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "profile-account-cellphone-dialog",
    attrs: {
      "title": "手机号认证",
      "size": "tiny",
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "hint"
  }, [_vm._v("绑定手机号可以用来登录和找回密码。")]), _vm._v(" "), _c('el-form', {
    ref: "cellphone"
  }, [_c('cellphone-input', {
    ref: "cellphoneInput",
    attrs: {
      "cellphone": _vm.cellphone,
      "captcha": _vm.captcha
    },
    on: {
      "update:cellphone": function($event) {
        _vm.cellphone = $event
      },
      "update:captcha": function($event) {
        _vm.captcha = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c094736"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile/account/cellphone.dialog.vue
// module id = 911
// module chunks = 3